import React, { useState, useEffect, useRef } from 'react';
import { Loader2, FileText } from 'lucide-react';

const EXTRACTION_MESSAGES = [
  'Analyzing purchase order...',
  'Reading line items...',
  'Extracting pricing details...',
  'Identifying ship-to address...',
  'Matching product data...',
  'Almost there...',
];

export default function ProcessingStage({ processingStatus, fileName, heading = 'Processing Order' }) {
  const [messageIndex, setMessageIndex] = useState(0);
  const isExtracting = processingStatus === 'Extracting order data...';
  const wasExtractingRef = useRef(false);

  useEffect(() => {
    if (isExtracting && !wasExtractingRef.current) {
      setMessageIndex(0);
    }
    wasExtractingRef.current = isExtracting;
  }, [isExtracting]);

  useEffect(() => {
    if (!isExtracting) return;
    const interval = setInterval(() => {
      setMessageIndex(i => (i + 1) % EXTRACTION_MESSAGES.length);
    }, 15000);
    return () => clearInterval(interval);
  }, [isExtracting]);

  const displayStatus = isExtracting ? EXTRACTION_MESSAGES[messageIndex] : processingStatus;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-6">
      <div className="w-full max-w-md text-center">
        <div className="w-20 h-20 mx-auto mb-6 bg-slate-800 rounded-2xl flex items-center justify-center relative">
          <Loader2 className="w-10 h-10 text-amber-400 animate-spin" />
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">{heading}</h2>
        <p className="text-slate-400 mb-8">{displayStatus}</p>

        <div className="bg-slate-800/50 rounded-xl p-4">
          <div className="flex items-center gap-3 text-slate-300">
            <FileText className="w-5 h-5 text-amber-400" />
            <span className="truncate">{fileName}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
